export const purchaseQueryKeys = {
  accountCodes: {
    all: ["account-codes"] as const,
  },
  audit: {
    all: ["audit"] as const,
  },
  budgets: {
    plans: ["budget-plan-list"] as const,
    plan: (budgetId: string) => ["budget-plan", budgetId] as const,
    summary: (budgetId: string) => ["budget-plan-summary", budgetId] as const,
    years: ["budget-years"] as const,
  },
  dashboard: {
    all: ["dashboard-summary"] as const,
  },
  invoices: {
    all: ["invoices"] as const,
    detail: (invoiceId: string) => ["invoice", invoiceId] as const,
    captureCandidates: ["invoice-capture-candidates"] as const,
  },
  items: {
    register: ["items", "register"] as const,
    registerDetail: (itemId: string) => ["items", "register", itemId] as const,
  },
  notifications: {
    list: ["notifications", "list"] as const,
    unread: ["notifications", "unread"] as const,
  },
  purchaseOrders: {
    all: ["purchase-orders"] as const,
    detail: (purchaseOrderId: string) => ["purchase-order", purchaseOrderId] as const,
  },
  requisitions: {
    all: ["requisitions"] as const,
    detail: (requisitionId: string) => ["requisition", requisitionId] as const,
  },
  reports: {
    all: ["reports"] as const,
  },
  rfqs: {
    all: ["rfqs"] as const,
    detail: (rfqId: string) => ["rfq", rfqId] as const,
    comparison: (rfqId: string) => ["rfq", rfqId, "comparison"] as const,
  },
  services: {
    register: ["services", "register"] as const,
  },
  trackers: {
    detail: (purchaseOrderId: string) => ["tracker", purchaseOrderId] as const,
  },
  vendors: {
    all: ["vendors"] as const,
    detail: (vendorId: string) => ["vendor", vendorId] as const,
  },
} as const;
